

















































































import { Component, Mixins, Inject } from 'vue-property-decorator';
import { getExternalData } from '@/apis/sheet';
import widgetCommon from './widgetCommon';
import { emitter } from '@/utils/mmit';
const getType = (data) => Object.prototype.toString.call(data).slice(8, -1);

@Component({
	name: 'externalControl',
})
export default class extends Mixins(widgetCommon) {
	@Inject({ default: {} }) public readonly recordVM!: any;
	private get rules() {
		return this.commonRule;
	}
	private loading: boolean = false;
	private selectData: any = {};
	private resData: object = Object.freeze({});

	private selectId: string = '';
	private showPicker: boolean = false;
	private showRadioPicker: boolean = false;
	private columns: any[] = [];

	private get isOutForm () {
		return this.$route.path === '/outForm';
	}
	// 设置靠左靠右或居中
	private get justifyContent() {
		const { position } = this.item;
		const pType = {
			1: '',
			2: {
				'justify-content': 'center',
			},
			3: {
				'justify-content': 'flex-end',
			},
		};
		return pType[position];
	}
	public mounted() {
		// 打开数据触发
		if (this.item.triggerType === 2) {
			this.sendRequest();
		}
		if (this.isOutForm) {
			const outFormKey = Object.keys(this.form);
			this.item.fieldMappings = this.item.fieldMappings.filter(item => outFormKey.includes(item.fieldBusinessId));
		}
	}
	private selectChange(md) {
		if (this.isReadOnly || this.disabled) {
			return;
		}
		md.showType === 1 ? this.showPicker = true : this.showRadioPicker = true;
		this.selectId = md.id;
		this.columns = md.options && md.options.map((item) => item.label);
	}
	private clear() {
		this.$set(this.selectData, this.selectId, null);
	}
	private onConfirm(value) {
		this.$set(this.selectData, this.selectId, value);
		this.showPicker = false;
		this.showRadioPicker = false;
		if (value) {
			this.setFormData();
		}
	}
	private async sendRequest() {
		this.loading = true;

		const { worksheetId, businessId: fieldBusinessId } = this.item;
		const params = {
			worksheetId,
			document: this.form,
			fieldBusinessId,
		};
		// 外部表单需要使用type = outForm
		const type = this.isOutForm ? 'outForm' : '';
		const res = await getExternalData(params, type);
		this.loading = false;
		if (res.code === 200 && res.data) {
			this.resData = this.changeTableData(res.data);
			this.setFormData();
		}
	}
	private changeTableData(data, objKey?) {
		// tslint:disable-next-line:forin
		for (let key in data) {
			const type = getType(data[key]);
			// 解析对象格式
			if (type === 'Object') {
				const objData = this.changeTableData(data[key], objKey ? objKey + '_' + key : key);
				data = { ...data, ...objData };
			} else {
				if (objKey) {
					const newKey = objKey + '_' + key;
					data[newKey] = data[key];
					delete data[key];
				}
			}
		}
		return data;
	}
	private setFormData() {
		this.generateMiddleware(this.resData);
		this.generateFieldMapping(this.resData);
	}
	// 中间件下拉数据生成
	private generateMiddleware(data) {
		if (!Object.keys(this.selectData).length) {
			// 生成中间件下拉数据
			this.item.middleWares.forEach((item) => {
				// 根据所选数组字段获取数据
				const [str1, str2] = item.arrayItem.split(',');
				const options = data[str1].map((ds) => {
					const label = ds[str2.replace(str1 + '_items_', '')];
					return {
						label,
						value: label,
					};
				});
				item.options = [...new Map(options.map((op) => [op.value, op])).values()];
			});
		}
	}
	// 字段映射页面数据回填
	private generateFieldMapping(data) {
		// 关联字段设置
		const reg = new RegExp('\\${external_(\\S+?)}', 'g');
		this.item.fieldMappings.forEach((item) => {
			let { fieldBusinessId, value, fieldType, selectArrayData } = item;
			if (fieldType === 'childTable') {
				this.form[fieldBusinessId] = [];
				const arrData = data[selectArrayData.value];
				const tableReg = new RegExp('<span class="mapping">([\\s\\S]*?)</span>', 'g');
				// 将value替换为数组中的对象
				arrData.forEach((ad) => {
					const objectValue = {};
					value.forEach((v) => {
						objectValue[v.fieldBusinessId] = v.value.replace(tableReg, (match, $1) => {
							return ad[$1.replace(selectArrayData.value + '_items_', '')];
						});
					});
					this.form[fieldBusinessId].push(objectValue);
				});
			} else {
				// 富文本字段需要先处理<for>标签
				if (fieldType === 'richText') {
					const richReg = new RegExp('<for>([\\s\\S]*?)</for>', 'g');
					value = value.replace(richReg, (match, $1) => {
						let result = [];
						// 统计返回数据中包含字段列表
						const arrayField: any = [];
						const arrayItemField: any = [];
						$1.replace(reg, (match1, $11: any) => {
							// 将所选数组字段及所选数组元素字段分别保存
							if (selectArrayData[$11]) {
								arrayField.push(selectArrayData[$11]);
								arrayItemField.push($11);
							}
						});
						// for标签未传数组时直接返回
						if (arrayField.length === 0) {
							return $1;
						} else if ([...new Set(arrayField)].length === 1) {
							// 遍历列表生成<p>标签 for标签中只能包含一个数组单位
							const bak$1 = $1;
							return data[arrayField[0]]
								.map((dr) => {
									$1 = bak$1.replace(reg, (match1, $11) => {
										// 如果是数组元素则遍历生成 不是就返回原始带$的
										if (arrayItemField.includes($11)) {
											return dr[$11.replace(selectArrayData[$11] + '_items_', '')];
										} else {
											return '${external_' + $11 + '}';
										}
									});
									return `<p>${$1}</p>`;
								})
								.join('\n');
						} else {
							console.log('解析<for>标签失败，不能填写多个数组');
						}
					});
				}
				// 普通字段直接替换
				this.form[fieldBusinessId] = value.replace(reg, (match, $1) => {
					if (data[$1] !== undefined) {
						const returnData = typeof data[$1] === 'boolean' ? data[$1] + '' : data[$1];
						return returnData;
					}
					return Object.keys(this.selectData).length ? this.findTableItem($1) : '';
				});
				if (fieldType === 'richText') {
					emitter.emit('changeRichText', fieldBusinessId);
				}
			}
		});
		// 生成完成需要触发页面变动通知
		this.$emit('change', this.form);
	}
	// 找到档期中间件所选的数组某一项 对应位置设置值
	private findTableItem(middleId) {
		const { selectData, resData } = this;
		const [id, key] = middleId.split('-');
		const middleware = this.item.middleWares.find((item) => item.id === id);
		const [str1, str2] = middleware.arrayItem.split(',');
		const selected = selectData[id];
		const tableItem = resData[str1].find(
			(item) => item[str2.replace(str1 + '_items_', '')] === selected
		);
		return tableItem[key];
	}
}
